import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export interface EventWizardPreviewModalTypes {
  // add props here
}

export const openEventWizardPreviewModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EVENT_WIZARD_PREVIEW_MODAL,
      panelProps: {},
    })
  );
};
